import { FunctionNodeInstance } from '@glueapp/graph-types';
import { FunctionNodeLayout } from '@/GraphEditor/drawingLayer/nodeComposition/FunctionNodeLayout';

interface Props {
    nodeInstance: FunctionNodeInstance;
}

export const FunctionNode: React.FC<Props> = ({ nodeInstance }) => {
    // Get the function name from the node instance state
    const functionName = nodeInstance.state?.functionName as string | undefined;

    return <FunctionNodeLayout nodeInstance={nodeInstance} functionName={functionName} />;
};
